import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchManageList, fetchUpdate, fetchDelete } from '@/api/PMS/estateManagement/notice/issueNotice';
import waves from '@/directive/waves'; // 水波纹指令

import noticeAdd from './add';
import viewList from './viewList';
export default {
  name: 'ComplexTable',
  components: {
    noticeAdd: noticeAdd,
    viewList: viewList
  },
  props: {
    isDashboard: Boolean,
    showDialog: {
      type: Boolean,
      default: false
    },
    detailID: {
      type: Number,
      default: null
    },
    isCustomDashboard: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          page: 1,
          limit: 10
        };
        this.getList();
      }
    }
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        title: ''
      },
      title: '',
      receiverObjectType: '',
      id: -1,
      dates: [],
      isDetail: false,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormViewListVisible: false,
      dialogFormDetailVisible: false,
      customClass: 'bhxcsqDialogSelect'
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleReadNum: function handleReadNum(id, receiverObjectType) {
      this.id = id;
      this.receiverObjectType = receiverObjectType;
      this.title = '阅读列表';
      this.dialogFormViewListVisible = true;
    },
    getNoticeTypeName: function getNoticeTypeName(val) {
      switch (val) {
        case 0:
          return '全体成员';

        case 1:
          return '全体物业';

        case 2:
          return '全体业主';

        case 3:
          return '全体租户';
      }
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    handDetailCancle: function handDetailCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormDetailVisible = false;
    },
    handViewListCancle: function handViewListCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormViewListVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.publishBeginDate = this.dates[0];
        this.listQuery.publishEndDate = this.dates[1];
      } else {
        this.listQuery.publishBeginDate = '';
        this.listQuery.publishEndDate = '';
      }

      if (this.isDashboard) {
        this.listQuery.publishStatus = 1;
      }

      fetchManageList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = '创建';
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    getRelease: function getRelease(id) {
      var _this2 = this;

      this.$confirm('你确定是要发布这条通知公告吗, 是否继续?', '提示').then(function () {
        fetchUpdate({
          id: id,
          publishStatus: 1
        }).then(function (res) {
          if (res.data.code === 200) {
            _this2.getList();

            _this2.Alert({
              alertType: 'update',
              message: '发布成功'
            });
          }
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = '编辑';
      this.isDetail = false;
      this.dialogFormVisible = true;
    },
    delete: function _delete(ids) {
      var _this3 = this;

      if (ids.length > 0) {
        this.$confirm('你确定是要删除本条通知公告吗, 是否继续?', '提示').then(function (res) {
          fetchDelete(ids).then(function (response) {
            _this3.getList();

            _this3.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    },
    // 详情
    getDetail: function getDetail(id) {
      this.id = id;
      this.isDetail = true;
      this.title = '详情';
      this.dialogFormVisible = true;
    }
  }
};